import { Add } from 'iconsax-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLoaderData } from 'react-router';
import { VList } from 'virtua';
import TabList from '@/components/common/tablist';
import { ContactListItem } from '@/components/contacts/contact-list/contact-list-item';
import EmptyLayout from '@/components/layouts/empty-layout';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import LoadingLayout from '@/components/layouts/progress-layout/loading-layout';
import VirtuaItem from '@/components/virtua/virtua-item';
import { useCategorizedGroups } from '@/hooks/contacts/use-groups';
import { useIsDesktop } from '@/hooks/use-user-platform';
import ROUTES, { type PromiseLoaderReturnType } from '@/routes';

export default function ContactGroupsIndexRoute() {
  const loaderData = useLoaderData<PromiseLoaderReturnType>();
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();
  const [selectedTab, setSelectedTab] = useState<'created' | 'joined'>('created');
  const { joinedGroups, createdGroups } = useCategorizedGroups();

  const selectedGroup = selectedTab === 'joined' ? joinedGroups : createdGroups;

  return (
    <PageLayout
      title={t('contact.groups.title')}
      headerConfig={{
        navigateBack: !isDesktop,
        actions: (
          <Link
            to={ROUTES.CONTACT.GROUPS.$.CREATE.$path({ relative: true })}
            relative='route'
            className='btn btn-square btn-ghost mode-embedded:btn-sm mode-embedded:text-inherit'>
            <Add className='size-6' />
          </Link>
        ),
        elementAfterNav: (
          <TabList
            className='mt-2 mb-0'
            onClickTab={setSelectedTab}
            tabs={[
              {
                key: 'created',
                label: 'contact.groups.created-groups',
              },
              {
                key: 'joined',
                label: 'contact.groups.joined-groups',
              },
            ]}
          />
        ),
      }}>
      <LoadingLayout promise={loaderData?.promises}>
        {() =>
          selectedGroup.length ? (
            <VList
              overscan={6}
              itemSize={64}
              className='flex-1 pb-safe'
              item={VirtuaItem}>
              {selectedGroup.map((group) => (
                <Link
                  key={group.ID}
                  to={ROUTES.MESSAGES.GROUPS.$buildPath({ params: { id: group.ID } })}>
                  <ContactListItem
                    item={group}
                    arrow
                  />
                </Link>
              ))}
            </VList>
          ) : (
            <EmptyLayout
              className='flex-1'
              label='contact.groups.empty'
            />
          )
        }
      </LoadingLayout>
    </PageLayout>
  );
}
